import { newDate } from "helpers/dateTools";
import { policyManagmentTypes } from "./types";
import { justNumbers } from "helpers/cleanString";

const {
  HANDLE_POLICYMANAGMENTS_INPUTS,
  SET_NEW_POLICY,
  GET_POLICY,
  CREATE_POLICY,
  DELETE_POLICYMANAGMENT,
  GET_POLICY_NUMBER,
  SET_POLICY_NOTES,
  ADD_MOVEMENT_TO_POLICY,
  EDIT_MOVEMENT_TO_POLICY,
  DELETE_MOVEMENT_TO_POLICY,
  GET_POLICY_ACCOUNTS,
  RESTORE_INITIAL,
  SEND_POLICY_TO_ORACLE,
  SET_MOVEMENTS,
} = policyManagmentTypes;

const initialState = {
  company: null,
  station: null,
  date: newDate(),
  policyManagments: [],
  policy: {},
  policyNotes: [],
  policyNumber: "",
  accounts: [],
};

export const policyManagmentReducer = (
  state = initialState,
  { type, payload }
) => {
  switch (type) {
    case HANDLE_POLICYMANAGMENTS_INPUTS:
      const { key, value } = payload;
      let newState = { ...state };
      if (key === "company") {
        newState = {
          ...state,
          [key]: value,
          station: null,
          policyNumber: "",
        };
      } else if (key === "station") {
        newState = {
          ...state,
          [key]: value,
          policyNumber: "",
        };
      } else if (key === "policyNumber") {
        const cleanValue = justNumbers(value);
        newState = {
          ...state,
          [key]: cleanValue,
        };
      } else {
        newState = {
          ...state,
          [key]: value,
        };
      }

      return { ...newState };
    case SET_NEW_POLICY:
      return {
        ...initialState,
        date: state.date,
      };
    case GET_POLICY:
      return { ...state, policy: payload };

    case CREATE_POLICY:
      return { ...state, policy: payload };
    case DELETE_POLICYMANAGMENT:
      return {
        ...state,
        policy: {},
      };
    case GET_POLICY_NUMBER:
      return { ...state, policyNumber: payload };

    case SET_POLICY_NOTES:
      return { ...state, policyNotes: payload };
    case SET_MOVEMENTS:
      return { ...state, policy: { ...state.policy, details: payload } };

    case ADD_MOVEMENT_TO_POLICY:
      const addDetails = [...state.policy.details, payload];
      return { ...state, policy: { ...state.policy, details: addDetails } };

    case EDIT_MOVEMENT_TO_POLICY:
      const editDetails = state.policy.details.map((item) =>
        item.id === payload.id ? { ...item, concept: payload.concept } : item
      );
      return {
        ...state,
        policy: { ...state.policy, details: editDetails },
      };
    case DELETE_MOVEMENT_TO_POLICY:
      if (payload.idPolicy) {
        return {
          ...state,
          policy: {
            ...state.policy,
            details: [],
          },
        };
      } else {
        const deleteDetails = state.policy.details.filter(
          (item) => item.id !== payload.id
        );
        return {
          ...state,
          policy: { ...state.policy, details: deleteDetails },
        };
      }

    case GET_POLICY_ACCOUNTS:
      return { ...state, accounts: payload };

    case SEND_POLICY_TO_ORACLE:
      return { ...state, policy: { ...state.policy, status: "SEND" } };
    case RESTORE_INITIAL:
      return initialState;

    default:
      return state;
  }
};
